import { DateFormatType } from './date-format-key'
import { HumanDateFormatType } from './human-date-format-type'
import { TimeFormatType } from './time-format-key'
import { DATE_FORMAT_PATTERNS } from './date-format-patterns'
import { TIME_FORMAT_PATTERNS } from './time-format-patterns'
import type { IDateFormatMap } from './i-date-format-map'
import { resolveDateFormat } from './resolve-date-format'
import { resolveTimeFormat } from './resolve-time-format'

export function buildDateFormatMap(
  timeFormat: TimeFormatType | null,
  dateFormat: DateFormatType | null,
): IDateFormatMap {
  const resolvedTimeFormat = resolveTimeFormat(timeFormat)
  const resolvedDateFormat = resolveDateFormat(dateFormat)
  const timePatterns = TIME_FORMAT_PATTERNS[resolvedTimeFormat]
  const datePatterns = DATE_FORMAT_PATTERNS[resolvedDateFormat]

  return {
    [HumanDateFormatType.Long]: `dddd, ${datePatterns.dateOnly}, ${timePatterns.timeOnly}`,
    [HumanDateFormatType.Short]: `${datePatterns.dayOnly}, ${timePatterns.timeOnly}`,
    [HumanDateFormatType.ShortAt]: `${datePatterns.dayOnly} [at] ${timePatterns.timeOnly}`,
    [HumanDateFormatType.ShortWithSeconds]: `${datePatterns.dayOnly} ${timePatterns.shortWithSeconds}`,
    [HumanDateFormatType.TimeOnly]: timePatterns.timeOnly,
    [HumanDateFormatType.DateOnly]: datePatterns.dateOnly,
    [HumanDateFormatType.DayHumanizedMonth]: datePatterns.dayHumanizedMonth,
    [HumanDateFormatType.DayOnly]: datePatterns.dayOnly,
    [HumanDateFormatType.HourOnly]: timePatterns.hourOnly,
    [HumanDateFormatType.DateWithShortMonth]: datePatterns.dateWithShortMonth,
    [HumanDateFormatType.DateLongMonth]: datePatterns.dateLongMonth,
    [HumanDateFormatType.DayLongMonth]: datePatterns.dayLongMonth,
    [HumanDateFormatType.DateTimeShort]: `${datePatterns.dateOnly} ${timePatterns.timeOnly}`,
    [HumanDateFormatType.ChatToday]: `[today], ${timePatterns.timeOnly}`,
    [HumanDateFormatType.ChatWeek]: `dddd, ${timePatterns.timeOnly}`,
    [HumanDateFormatType.ChatFull]: `${datePatterns.dateOnly}, ${timePatterns.timeOnly}`,
  }
}
